import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ANIMATION_DISTANCE = 20
const ITEM_CONTAINER_SIDE_PADDING = 16

class NestedHoverMenuItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      animating: false
    }

    this.revealHoverContent = this.revealHoverContent.bind(this)
    this.hideHoverContent = this.hideHoverContent.bind(this)
    this.popupClashTop = this.popupClashTop.bind(this)

    this.hoverMenuItem = React.createRef()
    this.itemHoverContainer = React.createRef()
  }

  popupClashTop () {
    const navbar = document.querySelector('.js-navbar')

    return (
      this.hoverMenuItem.current.getBoundingClientRect().top -
        navbar.clientHeight <=
      this.itemHoverContainer.current.clientHeight
    )
  }

  hoverItemClashLeft () {
    const hoverItemWidth = this.hoverMenuItem.current.clientWidth
    const hoverContainerLeftOffset = this.itemHoverContainer.current.getBoundingClientRect()
      .left
    return hoverItemWidth > hoverContainerLeftOffset
  }

  componentDidMount () {
    if (this.itemHoverContainer.current && !this.itemHoverContainerPositioned) {
      this.itemParent = this.hoverMenuItem.current.parentElement
      this.itemHoverContainerPositioned = true
      if (this.hoverItemClashLeft()) {
        this.itemHoverContainer.current.classList.add('pre-clash-left')
        this.itemHoverContainer.current.style.transform = `translate(${this
          .itemParent.clientWidth -
          ANIMATION_DISTANCE -
          ITEM_CONTAINER_SIDE_PADDING}px, 0)`
      } else {
        this.itemHoverContainer.current.style.transform = `translate(calc(-100% + ${ANIMATION_DISTANCE}px), 0)`
      }
    }
  }

  hideHoverContent () {
    if (this.allowAnimation()) {
      if (
        this.itemHoverContainer.current.classList.contains('pre-clash-left')
      ) {
        this.itemHoverContainer.current.classList.add('pre-clash-left')
        this.itemHoverContainer.current.style.transform = `translate(${this
          .itemParent.clientWidth - ANIMATION_DISTANCE}px, 0)`
      } else {
        this.itemHoverContainer.current.style.transform = `translate(calc(-100% + ${ANIMATION_DISTANCE}px), 0)`
      }

      this.setState({ active: false })
    }
  }

  revealHoverContent () {
    if (this.allowAnimation()) {
      this.setState({ animating: true, active: true })

      if (this.popupClashTop()) {
        this.itemHoverContainer.current.classList.add('clash-top')
      } else {
        this.itemHoverContainer.current.classList.remove('clash-top')
      }

      if (
        this.itemHoverContainer.current.classList.contains('pre-clash-left')
      ) {
        this.itemHoverContainer.current.style.transform = `translate(${this
          .itemParent.clientWidth - ITEM_CONTAINER_SIDE_PADDING}px, 0)`
      } else {
        this.itemHoverContainer.current.style.transform =
          'translate(calc(-100%), 0)'
      }
    }
  }

  allowAnimation () {
    return (
      (window.innerWidth > 768 || !this.props.hoverEffectDesktopOnly) &&
      !this.state.animating &&
      this.props.subMenu
    )
  }

  render () {
    let processingIcon

    if (this.props.processing) {
      processingIcon = (
        <span>
          <i className='fa fa-spinner fa-spin' />
        </span>
      )
    }

    let hoverableIcon
    if (this.props.subMenu) {
      hoverableIcon = <i className='fa fa-angle-right' />
    }

    const hoverMenuItemClass = classNames('NestedHoverMenuItem', {
      'NestedHoverMenuItem--hover': this.state.active,
      'NestedHoverMenuItem--included': this.props.marked,
      'NestedHoverMenuItem--nonActive': this.props.nonActive,
      underlined: this.props.underlined
    })

    let hoverContainer
    if (this.props.subMenu) {
      hoverContainer = (
        <ul
          className='NestedHoverMenuItem__hoverContainer'
          ref={this.itemHoverContainer}
        >
          {this.props.subMenu}
        </ul>
      )
    }

    return (
      <li
        className={hoverMenuItemClass}
        onMouseEnter={this.revealHoverContent}
        onMouseLeave={this.hideHoverContent}
        onTransitionEnd={() => {
          this.setState({ animating: false })
        }}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          this.props.handleClick()
        }}
        ref={this.hoverMenuItem}
      >
        <div className='NestedHoverMenuItem__content'>
          <div className='NestedHoverMenuItem__itemLabel'>
            {this.props.label}
            {processingIcon}
          </div>
          {hoverableIcon}
          {hoverContainer}
        </div>
      </li>
    )
  }
}

NestedHoverMenuItem.defaultProps = {
  hoverEffectDesktopOnly: true
}

NestedHoverMenuItem.propTypes = {
  hoverEffectDesktopOnly: PropTypes.bool,
  processing: PropTypes.bool,
  label: PropTypes.string,
  marked: PropTypes.bool,
  subMenu: PropTypes.node,
  handleClick: PropTypes.func,
  underlined: PropTypes.bool
}

export default NestedHoverMenuItem
